var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"ma-0 pa-0",attrs:{"hide-details":"","label":"Группа здоровья","prepend-icon":"add_circle_outline","item-text":"name","item-value":"id","items":_vm.items,"loading":_vm.loading},on:{"change":_vm.save},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }